import React, { useState, useEffect, useCallback } from 'react';
import RenderSpectrum from './RenderSpectrum';
import './App.css';

function App() {
  const [renderCount, setRenderCount] = useState(0);
  const [lightMode, toggleLightMode] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return !!urlParams.get('light');
  });
  const generateNew = useCallback(() => setRenderCount(r => r + 1), [
    setRenderCount,
  ]);
  const globalToggleLightMode = useCallback(() => {
    toggleLightMode(l => {
      return !l;
    });
    generateNew();
  }, [generateNew, toggleLightMode]);

  useEffect(() => {
    const updateOnSpace = e => {
      if (e.keyCode === 32) {
        e.preventDefault();
        generateNew();
      }
    };

    const lightToggle = e => {
      if (e.keyCode === 69) {
        e.preventDefault();
        globalToggleLightMode();
      }
    };

    window.addEventListener('keydown', lightToggle, true);
    window.addEventListener('keydown', updateOnSpace, true);

    return () => {
      window.removeEventListener('keydown', updateOnSpace, true);
      window.addEventListener('keydown', lightToggle, true);
    };
  }, [generateNew, globalToggleLightMode]);

  return (
    <div className="App">
      <div>
        <div>
          <h1>
            <a
              href="https://github.com/ganapativs/react-spectrum"
              rel="noopener noreferrer"
              target="_blank">
              react-spectrum
            </a>{' '}
            🎉
          </h1>
          <h4>
            <b>GitHub: </b>
            <a
              href="https://github.com/ganapativs/react-spectrum"
              rel="noopener noreferrer"
              target="_blank">
              https://github.com/ganapativs/react-spectrum
            </a>
          </h4>
        </div>
      </div>
      <RenderSpectrum
        key={renderCount}
        // On the first mount, read the config from URL
        readConfigFromURL={renderCount === 0}
        generateNew={generateNew}
        toggleLightMode={globalToggleLightMode}
        lightBackground={lightMode}
      />
      <p>
        Made in{' '}
        <span role="img" aria-label="India" title="India">
          🇮🇳
        </span>{' '}
        by{' '}
        <a
          href="https://twitter.com/ganapativs"
          rel="noopener noreferrer"
          target="_blank">
          @ganapativs
        </a>
      </p>
    </div>
  );
}

export default App;
